/**
 * Enhances Bootstrap's collapsible navbar by adding custom event listeners.
 *
 * This script adds two new behaviors to the Bootstrap collapse implementation:
 * 1. Collapses the navbar when a click occurs outside of the navbar or its toggle button (focus out).
 * 2. Collapses the navbar when the Escape key is pressed.
 *
 * These enhancements improve accessibility and user experience by allowing users to easily close
 * the navigation menu without interacting directly with the toggle button.
 *
 */

const toggle = document.querySelector('#navbar-toggle');
const nav = document.querySelector('#collapsible-nav');

const isNavCollapsed = (event: MouseEvent | KeyboardEvent): boolean => {
  if (!nav || !toggle || !nav.classList.contains('in')) return false;
  if (event.type === 'keydown' && (event as KeyboardEvent).key === 'Escape') return true;
  if (
    event.type === 'mousedown' &&
    !nav.contains((event as MouseEvent).target as Node) &&
    !toggle.contains((event as MouseEvent).target as Node)
  )
    return true;
  return false;
};

const closeCollapsibleNav = (): void => {
  if (!nav || !toggle) return;
  // Start the collapse transition
  (nav as HTMLElement).style.height = `${nav.scrollHeight}px`; // set to current height to trigger transition
  nav.classList.remove('in');
  nav.classList.remove('collapse');
  nav.classList.add('collapsing');

  // eslint-disable-next-line no-void
  void (nav as HTMLElement).offsetHeight; // Force reflow to ensure the transition is applied

  // Animate to height 1
  (nav as HTMLElement).style.height = '1px'; // collapse to height 1 like Bootstrap does

  setTimeout(() => {
    nav.classList.remove('collapsing');
    nav.classList.add('collapse');
    (nav as HTMLElement).style.height = '';
  }, 350); // match Bootstrap's collapse transition duration

  toggle.setAttribute('aria-expanded', 'false');
};

if (toggle && nav) {
  document.addEventListener('mousedown', (event) => {
    if (isNavCollapsed(event)) {
      closeCollapsibleNav();
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (isNavCollapsed(event)) {
      closeCollapsibleNav();
      (toggle as HTMLElement).blur();
      event.preventDefault();
    }
  });
}
